// import React from "react";
// import { Spinner } from "react-bootstrap";
// import '../../components/DriftComponents/loader.css'; 
 

// const Loader = ({ isFullScreenLoading }) => {
//   if (!isFullScreenLoading) return null;

//   console.log("Loader coming ", isFullScreenLoading)

//   return (

//       <div className="loader-overlay">
//       <div className="loader-spinner text-center">
//         {/* Pure CSS spinner */}
//         <div className="css-spinner"></div>
//       </div>
//     </div>
//   );
// };

// export default Loader;


import React from "react";
import '../../components/DriftComponents/loader.css'; 

const Loader = ({ isFullScreenLoading }) => {
  if (!isFullScreenLoading) return null;

  console.log("Loader coming ", isFullScreenLoading)

  return (
    <div className="loader-overlay">
      <div className="loader-spinner text-center">
        <img
          src="/driftAssets/black_color_Logo.png"
          alt="site logo"
          className="loading-logo"
        />
      </div>
    </div>
  );
};

export default Loader;